export type GeoCoordinate = {
  lat: number;
  lng: number;
};

export function parseGeoCoordinate(value: unknown): number | null {
  if (value == null || value === '') {
    return null;
  }

  const coordinate = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(coordinate) ? coordinate : null;
}

export function toGeoCoordinate(lat: unknown, lng: unknown): GeoCoordinate | null {
  const parsedLat = parseGeoCoordinate(lat);
  const parsedLng = parseGeoCoordinate(lng);

  if (parsedLat == null || parsedLng == null) {
    return null;
  }

  return { lat: parsedLat, lng: parsedLng };
}
